/* tslint:disable */
/* eslint-disable */
/**
 * FMS Run API
 * The FMS Run API description
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from '../configuration';
import type { AxiosPromise, AxiosInstance, RawAxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, type RequestArgs, BaseAPI, RequiredError, operationServerMap } from '../base';
// @ts-ignore
import type { ActivitySubmissionDetailsDto } from '../model';
// @ts-ignore
import type { CreateSubmissionDto } from '../model';
// @ts-ignore
import type { DeclineSubmissionDto } from '../model';
// @ts-ignore
import type { PaginatedSubmissionsResponseDto } from '../model';
// @ts-ignore
import type { SubmissionDto } from '../model';
/**
 * SubmissionsApi - axios parameter creator
 * @export
 */
export const SubmissionsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Approve a submission - updates total distance and participation status
         * @param {string} id Submission ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        submissionsControllerApproveSubmission: async (id: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('submissionsControllerApproveSubmission', 'id', id)
            const localVarPath = `/api/submissions/{id}/approve`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Create a new challenge category participation submission for an existing activity
         * @param {CreateSubmissionDto} createSubmissionDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        submissionsControllerCreateSubmission: async (createSubmissionDto: CreateSubmissionDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'createSubmissionDto' is not null or undefined
            assertParamExists('submissionsControllerCreateSubmission', 'createSubmissionDto', createSubmissionDto)
            const localVarPath = `/api/submissions`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createSubmissionDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Decline a submission with a reason
         * @param {string} id Submission ID
         * @param {DeclineSubmissionDto} declineSubmissionDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        submissionsControllerDeclineSubmission: async (id: string, declineSubmissionDto: DeclineSubmissionDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('submissionsControllerDeclineSubmission', 'id', id)
            // verify required parameter 'declineSubmissionDto' is not null or undefined
            assertParamExists('submissionsControllerDeclineSubmission', 'declineSubmissionDto', declineSubmissionDto)
            const localVarPath = `/api/submissions/{id}/decline`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(declineSubmissionDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Export submissions CSV with optional filters
         * @param {string | null} [search] Search term to filter submissions
         * @param {SubmissionsControllerExportCsvStatusEnum} [status] Filter by submission status
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        submissionsControllerExportCsv: async (search?: string | null, status?: SubmissionsControllerExportCsvStatusEnum, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/submissions/export/csv`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (search !== undefined) {
                localVarQueryParameter['search'] = search;
            }

            if (status !== undefined) {
                localVarQueryParameter['status'] = status;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get comprehensive activity submission details by activityId and participationId
         * @param {string} activityId Activity ID
         * @param {string} participationId Participation ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        submissionsControllerFindActivitySubmissionDetails: async (activityId: string, participationId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'activityId' is not null or undefined
            assertParamExists('submissionsControllerFindActivitySubmissionDetails', 'activityId', activityId)
            // verify required parameter 'participationId' is not null or undefined
            assertParamExists('submissionsControllerFindActivitySubmissionDetails', 'participationId', participationId)
            const localVarPath = `/api/submissions/by-activity-participation`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (activityId !== undefined) {
                localVarQueryParameter['activityId'] = activityId;
            }

            if (participationId !== undefined) {
                localVarQueryParameter['participationId'] = participationId;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get all submissions with pagination
         * @param {number} [page] Page number (default: 1)
         * @param {number} [limit] Number of items per page (default: 10, max: 100)
         * @param {string} [search] Search term for filtering results
         * @param {SubmissionsControllerFindAllSubmissionsPaginatedStatusEnum} [status] Status filter for submissions
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        submissionsControllerFindAllSubmissionsPaginated: async (page?: number, limit?: number, search?: string, status?: SubmissionsControllerFindAllSubmissionsPaginatedStatusEnum, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/submissions/paginated`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }

            if (search !== undefined) {
                localVarQueryParameter['search'] = search;
            }

            if (status !== undefined) {
                localVarQueryParameter['status'] = status;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get all submissions for a specific participation
         * @param {string} participationId Participation ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        submissionsControllerFindSubmissionsByParticipation: async (participationId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'participationId' is not null or undefined
            assertParamExists('submissionsControllerFindSubmissionsByParticipation', 'participationId', participationId)
            const localVarPath = `/api/submissions/by-participation/{participationId}`
                .replace(`{${"participationId"}}`, encodeURIComponent(String(participationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * SubmissionsApi - functional programming interface
 * @export
 */
export const SubmissionsApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = SubmissionsApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Approve a submission - updates total distance and participation status
         * @param {string} id Submission ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async submissionsControllerApproveSubmission(id: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SubmissionDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.submissionsControllerApproveSubmission(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SubmissionsApi.submissionsControllerApproveSubmission']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Create a new challenge category participation submission for an existing activity
         * @param {CreateSubmissionDto} createSubmissionDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async submissionsControllerCreateSubmission(createSubmissionDto: CreateSubmissionDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SubmissionDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.submissionsControllerCreateSubmission(createSubmissionDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SubmissionsApi.submissionsControllerCreateSubmission']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Decline a submission with a reason
         * @param {string} id Submission ID
         * @param {DeclineSubmissionDto} declineSubmissionDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async submissionsControllerDeclineSubmission(id: string, declineSubmissionDto: DeclineSubmissionDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SubmissionDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.submissionsControllerDeclineSubmission(id, declineSubmissionDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SubmissionsApi.submissionsControllerDeclineSubmission']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Export submissions CSV with optional filters
         * @param {string | null} [search] Search term to filter submissions
         * @param {SubmissionsControllerExportCsvStatusEnum} [status] Filter by submission status
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async submissionsControllerExportCsv(search?: string | null, status?: SubmissionsControllerExportCsvStatusEnum, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.submissionsControllerExportCsv(search, status, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SubmissionsApi.submissionsControllerExportCsv']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Get comprehensive activity submission details by activityId and participationId
         * @param {string} activityId Activity ID
         * @param {string} participationId Participation ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async submissionsControllerFindActivitySubmissionDetails(activityId: string, participationId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ActivitySubmissionDetailsDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.submissionsControllerFindActivitySubmissionDetails(activityId, participationId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SubmissionsApi.submissionsControllerFindActivitySubmissionDetails']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Get all submissions with pagination
         * @param {number} [page] Page number (default: 1)
         * @param {number} [limit] Number of items per page (default: 10, max: 100)
         * @param {string} [search] Search term for filtering results
         * @param {SubmissionsControllerFindAllSubmissionsPaginatedStatusEnum} [status] Status filter for submissions
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async submissionsControllerFindAllSubmissionsPaginated(page?: number, limit?: number, search?: string, status?: SubmissionsControllerFindAllSubmissionsPaginatedStatusEnum, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PaginatedSubmissionsResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.submissionsControllerFindAllSubmissionsPaginated(page, limit, search, status, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SubmissionsApi.submissionsControllerFindAllSubmissionsPaginated']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Get all submissions for a specific participation
         * @param {string} participationId Participation ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async submissionsControllerFindSubmissionsByParticipation(participationId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<SubmissionDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.submissionsControllerFindSubmissionsByParticipation(participationId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SubmissionsApi.submissionsControllerFindSubmissionsByParticipation']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * SubmissionsApi - factory interface
 * @export
 */
export const SubmissionsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = SubmissionsApiFp(configuration)
    return {
        /**
         * 
         * @summary Approve a submission - updates total distance and participation status
         * @param {string} id Submission ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        submissionsControllerApproveSubmission(id: string, options?: RawAxiosRequestConfig): AxiosPromise<SubmissionDto> {
            return localVarFp.submissionsControllerApproveSubmission(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Create a new challenge category participation submission for an existing activity
         * @param {CreateSubmissionDto} createSubmissionDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        submissionsControllerCreateSubmission(createSubmissionDto: CreateSubmissionDto, options?: RawAxiosRequestConfig): AxiosPromise<SubmissionDto> {
            return localVarFp.submissionsControllerCreateSubmission(createSubmissionDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Decline a submission with a reason
         * @param {string} id Submission ID
         * @param {DeclineSubmissionDto} declineSubmissionDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        submissionsControllerDeclineSubmission(id: string, declineSubmissionDto: DeclineSubmissionDto, options?: RawAxiosRequestConfig): AxiosPromise<SubmissionDto> {
            return localVarFp.submissionsControllerDeclineSubmission(id, declineSubmissionDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Export submissions CSV with optional filters
         * @param {string | null} [search] Search term to filter submissions
         * @param {SubmissionsControllerExportCsvStatusEnum} [status] Filter by submission status
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        submissionsControllerExportCsv(search?: string | null, status?: SubmissionsControllerExportCsvStatusEnum, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.submissionsControllerExportCsv(search, status, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get comprehensive activity submission details by activityId and participationId
         * @param {string} activityId Activity ID
         * @param {string} participationId Participation ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        submissionsControllerFindActivitySubmissionDetails(activityId: string, participationId: string, options?: RawAxiosRequestConfig): AxiosPromise<ActivitySubmissionDetailsDto> {
            return localVarFp.submissionsControllerFindActivitySubmissionDetails(activityId, participationId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get all submissions with pagination
         * @param {number} [page] Page number (default: 1)
         * @param {number} [limit] Number of items per page (default: 10, max: 100)
         * @param {string} [search] Search term for filtering results
         * @param {SubmissionsControllerFindAllSubmissionsPaginatedStatusEnum} [status] Status filter for submissions
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        submissionsControllerFindAllSubmissionsPaginated(page?: number, limit?: number, search?: string, status?: SubmissionsControllerFindAllSubmissionsPaginatedStatusEnum, options?: RawAxiosRequestConfig): AxiosPromise<PaginatedSubmissionsResponseDto> {
            return localVarFp.submissionsControllerFindAllSubmissionsPaginated(page, limit, search, status, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get all submissions for a specific participation
         * @param {string} participationId Participation ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        submissionsControllerFindSubmissionsByParticipation(participationId: string, options?: RawAxiosRequestConfig): AxiosPromise<Array<SubmissionDto>> {
            return localVarFp.submissionsControllerFindSubmissionsByParticipation(participationId, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * SubmissionsApi - object-oriented interface
 * @export
 * @class SubmissionsApi
 * @extends {BaseAPI}
 */
export class SubmissionsApi extends BaseAPI {
    /**
     * 
     * @summary Approve a submission - updates total distance and participation status
     * @param {string} id Submission ID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SubmissionsApi
     */
    public submissionsControllerApproveSubmission(id: string, options?: RawAxiosRequestConfig) {
        return SubmissionsApiFp(this.configuration).submissionsControllerApproveSubmission(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Create a new challenge category participation submission for an existing activity
     * @param {CreateSubmissionDto} createSubmissionDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SubmissionsApi
     */
    public submissionsControllerCreateSubmission(createSubmissionDto: CreateSubmissionDto, options?: RawAxiosRequestConfig) {
        return SubmissionsApiFp(this.configuration).submissionsControllerCreateSubmission(createSubmissionDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Decline a submission with a reason
     * @param {string} id Submission ID
     * @param {DeclineSubmissionDto} declineSubmissionDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SubmissionsApi
     */
    public submissionsControllerDeclineSubmission(id: string, declineSubmissionDto: DeclineSubmissionDto, options?: RawAxiosRequestConfig) {
        return SubmissionsApiFp(this.configuration).submissionsControllerDeclineSubmission(id, declineSubmissionDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Export submissions CSV with optional filters
     * @param {string | null} [search] Search term to filter submissions
     * @param {SubmissionsControllerExportCsvStatusEnum} [status] Filter by submission status
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SubmissionsApi
     */
    public submissionsControllerExportCsv(search?: string | null, status?: SubmissionsControllerExportCsvStatusEnum, options?: RawAxiosRequestConfig) {
        return SubmissionsApiFp(this.configuration).submissionsControllerExportCsv(search, status, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get comprehensive activity submission details by activityId and participationId
     * @param {string} activityId Activity ID
     * @param {string} participationId Participation ID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SubmissionsApi
     */
    public submissionsControllerFindActivitySubmissionDetails(activityId: string, participationId: string, options?: RawAxiosRequestConfig) {
        return SubmissionsApiFp(this.configuration).submissionsControllerFindActivitySubmissionDetails(activityId, participationId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get all submissions with pagination
     * @param {number} [page] Page number (default: 1)
     * @param {number} [limit] Number of items per page (default: 10, max: 100)
     * @param {string} [search] Search term for filtering results
     * @param {SubmissionsControllerFindAllSubmissionsPaginatedStatusEnum} [status] Status filter for submissions
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SubmissionsApi
     */
    public submissionsControllerFindAllSubmissionsPaginated(page?: number, limit?: number, search?: string, status?: SubmissionsControllerFindAllSubmissionsPaginatedStatusEnum, options?: RawAxiosRequestConfig) {
        return SubmissionsApiFp(this.configuration).submissionsControllerFindAllSubmissionsPaginated(page, limit, search, status, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get all submissions for a specific participation
     * @param {string} participationId Participation ID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SubmissionsApi
     */
    public submissionsControllerFindSubmissionsByParticipation(participationId: string, options?: RawAxiosRequestConfig) {
        return SubmissionsApiFp(this.configuration).submissionsControllerFindSubmissionsByParticipation(participationId, options).then((request) => request(this.axios, this.basePath));
    }
}

/**
 * @export
 */
export const SubmissionsControllerExportCsvStatusEnum = {
    Pending: 'pending',
    Approved: 'approved',
    Declined: 'declined'
} as const;
export type SubmissionsControllerExportCsvStatusEnum = typeof SubmissionsControllerExportCsvStatusEnum[keyof typeof SubmissionsControllerExportCsvStatusEnum];
/**
 * @export
 */
export const SubmissionsControllerFindAllSubmissionsPaginatedStatusEnum = {
    Pending: 'pending',
    Approved: 'approved',
    Declined: 'declined'
} as const;
export type SubmissionsControllerFindAllSubmissionsPaginatedStatusEnum = typeof SubmissionsControllerFindAllSubmissionsPaginatedStatusEnum[keyof typeof SubmissionsControllerFindAllSubmissionsPaginatedStatusEnum];
